import { render, staticRenderFns } from "./Intelipost.vue?vue&type=template&id=e42b7cd8"
import script from "./Intelipost.vue?vue&type=script&lang=js"
export * from "./Intelipost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports